"use client";
import r from "react";
import { FileUpload as t, FileUploadHiddenInput as N, FileUploadContext as U } from "@ark-ui/react";
import { useFileUpload as oe, useFileUploadContext as ie } from "@ark-ui/react";
import { fileUpload as v } from "@huspy/styled-system/recipes";
import { useSortable as y } from "@dnd-kit/sortable";
import { CSS as x } from "@dnd-kit/utilities";
import { GripVertical as P } from "lucide-react";
import { css as T } from "@huspy/styled-system/css";
import { createStyleContext as S } from "../../utils/createStyleContext.mjs";
import { Button as w } from "../button/button.mjs";
import { Sortable as z } from "./sortable.mjs";
const { withProvider: m, withContext: o } = S(v), D = m(t.Root, "root"), R = m(t.RootProvider, "rootProvider"), h = o(
  t.Dropzone,
  "dropzone"
), C = o(t.ItemDeleteTrigger, "itemDeleteTrigger"), G = o(
  ({ children: i, ...a }) => /* @__PURE__ */ r.createElement(t.ItemGroup, { ...a }, i),
  "itemGroup"
), E = o(
  t.ItemName,
  "itemName"
), H = o(t.ItemPreviewImage, "itemPreviewImage"), L = o(t.ItemPreview, "itemPreview"), p = o(t.Item, "item"), k = {
  position: "absolute",
  bottom: "spacing-1",
  left: "spacing-1",
  zIndex: 10,
  width: "20px",
  minWidth: "auto",
  height: "20px",
  padding: "spacing-1",
  backgroundColor: "alpha-black-50",
  backdropFilter: "blur(8px)",
  borderRadius: "radius-1"
};
function B({
  id: i,
  children: a,
  disableSorting: l = !1,
  absoluteButtonPosition: d = !1,
  ...n
}) {
  const {
    attributes: s,
    isDragging: I,
    listeners: c,
    setNodeRef: g,
    setActivatorNodeRef: u,
    transform: b,
    transition: f
  } = y({
    id: l ? null : i,
    disabled: l
  }), F = {
    opacity: I ? 0.4 : void 0,
    transform: x.Translate.toString(b),
    transition: f
  };
  return /* @__PURE__ */ r.createElement(p, { ref: g, style: F, ...n }, !l && /* @__PURE__ */ r.createElement(
    w,
    {
      type: "button",
      ...s,
      ...c,
      ref: u,
      "aria-label": "Sorting Trigger",
      className: T({
        cursor: "grab",
        display: "flex",
        alignItems: "center",
        _active: { cursor: "grabbing" },
        ...d && k
      })
    },
    /* @__PURE__ */ r.createElement(P, { size: 12, color: "white" })
  ), a);
}
const A = o(
  B,
  "sortableItem"
), V = o(t.ItemSizeText, "itemSizeText"), W = o(
  t.Label,
  "label"
), _ = o(
  t.Trigger,
  "trigger"
), $ = o((i) => /* @__PURE__ */ r.createElement(N, { "data-testid": "file-upload-input", ...i }), "hiddenInput"), e = {
  Context: U,
  Provider: R,
  Dropzone: h,
  HiddenInput: $,
  ItemDeleteTrigger: C,
  ItemGroup: G,
  ItemName: E,
  ItemPreviewImage: H,
  ItemPreview: L,
  Item: p,
  ItemSizeText: V,
  Label: W,
  Root: D,
  Trigger: _,
  Sortable: z,
  SortableItem: A
};
e.Provider.displayName = "FileUploadProvider";
e.Dropzone.displayName = "FileUploadDropzone";
e.HiddenInput.displayName = "FileUploadHiddenInput";
e.ItemDeleteTrigger.displayName = "FileUploadItemDeleteTrigger";
e.ItemGroup.displayName = "FileUploadItemGroup";
e.ItemName.displayName = "FileUploadItemName";
e.ItemPreviewImage.displayName = "FileUploadItemPreviewImage";
e.ItemPreview.displayName = "FileUploadItemPreview";
e.Item.displayName = "FileUploadItem";
e.ItemSizeText.displayName = "FileUploadItemSizeText";
e.Label.displayName = "FileUploadLabel";
e.Root.displayName = "FileUploadRoot";
e.Trigger.displayName = "FileUploadTrigger";
e.SortableItem.displayName = "FileUploadSortableItem";
export {
  B as BaseSortableItem,
  e as FileUpload,
  oe as useFileUpload,
  ie as useFileUploadContext
};
